import { Box, CircularProgress, Grid, Theme, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { customSwitch } from 'utils/customSwitchCase/customSwitch';
import { getNotificationKpiTileIcon } from '../../Notification/KPIMetric/Helper';
import { TabTitle } from '../../PerformanceReport';
import { getTaskKpiTileIcon } from '../../Task/KPIMetric/Helper';

import { IKPITileProps } from './Tile';

export interface titleStyleProps {
  height: number;
}

const titleStyle = makeStyles<{ disabled: boolean; selectedMetric: any; primaryLabel: any }>()(
  (theme: Theme, props) => ({
    root: {
      width: '275px',
      height: '90px',
      cursor: props.disabled ? 'not-allowed' : 'pointer',
      boxShadow:
        props.primaryLabel === props.selectedMetric
          ? '0px 0px 10px rgba(0, 0, 0, 0.1)'
          : '0px 0px 0px rgba(0, 0, 0, 0)',
      border: props.primaryLabel === props.selectedMetric ? '3px solid #2196f3' : '1px solid #E3DFDF',
      borderRadius: '10px',
      '&:hover': {
        backgroundColor: props.primaryLabel !== props.selectedMetric ? '#eee' : '#fff',
        border: props.primaryLabel !== props.selectedMetric ? '1.5px solid #888' : '3px solid #2196f3',
      },
    },
    container: {
      margin: '4% 6%',
    },
    iconCircle: {
      height: '55px',
      width: '55px',
      position: 'relative',
      display: 'inline-flex',
      margin: '6%',
    },
    circularProgress: {
      height: '60px !important',
      width: '60px !important',
      position: 'absolute',
      bottom: '-3px',
      left: '-3px',
      color: '#5FB157',
    },
    iconContainer: {
      borderRadius: '50%',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    label: {
      marginTop: '4%',
    },
    primary: {
      color: '#555',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: 1,
    },
    secondary: {
      fontSize: '15px',
      position: 'relative',
      top: '-5px',
      paddingLeft: '5px',
    },
    value: {
      color: '#333',
      fontWeight: 500,
    },
  }),
);

export default function KpiTile(props: IKPITileProps) {
  const { title, primaryLabel, secondaryLabel, showProgress = false, value, onClickHandler, disabled = false } = props;
  const { classes } = titleStyle({
    disabled: props.disabled,
    selectedMetric: props.selectedMetric,
    primaryLabel: props.primaryLabel,
  });

  const getKpiTileIcon = customSwitch({
    [TabTitle.communication]: getNotificationKpiTileIcon(primaryLabel),
    [TabTitle.task]: getTaskKpiTileIcon(primaryLabel),
  })(undefined);

  function CircularProgressWithContent() {
    return (
      <Box className={classes.iconCircle}>
        {showProgress && (
          <CircularProgress thickness={2} variant="determinate" value={Number(value)} className={classes.circularProgress} />
        )}
        <Box boxShadow={5} className={classes.iconContainer}>
          <div
            style={{
              filter:
                showProgress && value
                  ? 'invert(30%) sepia(93%) saturate(1352%) hue-rotate(87deg) brightness(119%) contrast(119%)'
                  : 'none',
            }}
          >
            {getKpiTileIcon(title)}
          </div>
        </Box>
      </Box>
    );
  }

  return (
    <Box className={classes.root} m={1} onClick={() => !disabled && onClickHandler(primaryLabel)}>
      <Grid container className={classes.container}>
        <Grid item xs={3}>
          <CircularProgressWithContent />
        </Grid>
        <Grid item xs={7} className={classes.label}>
          <Typography className={classes.primary}>{primaryLabel}</Typography>
          {value !== null && value !== undefined ? (
            <Typography variant="h5" className={classes.value}>
              {value}
              <span className={classes.secondary}>{secondaryLabel}</span>
            </Typography>
          ) : (
            <CircularProgress thickness={3} />
          )}
        </Grid>
      </Grid>
    </Box>
  );
}
